{
	"accessibility.table.selectRow": "Select row",
	"accessibility.topbar.openMainMenu": "Open main menu",
	"accessibility.topbar.openUserMenu": "Open account menu",
	"account.accountDetails.label.email": "Email address",
	"account.accountDetails.label.firstName": "First name",
	"account.accountDetails.label.lastName": "Last name",
	"account.accountDetails.label.name": "Account name",
	"account.accountDetails.label.selfDescription": "Short description",
	"account.applicationDetails.label.heardAboutSource": "How did you hear about the program?",
	"account.applicationDetails.label.productCategories": "Which product categories will you promote?",
	"account.applicationDetails.label.promoteProgramme": "How will you promote the Affiliate Program?",
	"account.applicationDetails.label.recommendedBy": "Who recommended you?",
	"account.paymentInformation.label.accountHolder": "Account holder",
	"account.paymentInformation.label.bankName": "Bank name",
	"account.paymentInformation.label.bic": "BIC",
	"account.paymentInformation.label.emailAdress": "Email address",
	"account.paymentInformation.label.fedwireCode": "FEDWIRE Code",
	"account.paymentInformation.label.iban": "IBAN",
	"account.paymentInformation.label.intervalType": "Payout interval",
	"account.paymentInformation.label.intlAccountNumber": "Account Number",
	"account.paymentInformation.label.intlBankName": "Bank Name",
	"account.paymentInformation.label.paymentType": "Payment method",
	"account.paymentInformation.label.swiftCode": "SWIFT Code",
	"account.paymentInformation.label.taxId": "Tax ID",
	"account.paymentInformation.label.tradeRegister": "Company registration number",
	"account.paymentInformation.label.valueAddedTaxId": "VAT ID",
	"account.setup.backward": "Back",
	"account.setup.channels.title": "Which platform do you feel at home on?",
	"account.setup.complete": "Complete application",
	"account.setup.continue": "Next step",
	"account.setup.firstStep.description": "To receive your application, you must complete and submit the form.",
	"account.setup.firstStep.title": "Application for {0} by {1}",
	"account.setup.skipSetup.button": "Skip Account Setup",
	"account.setup.skipSetup.description": "If you skip the account setup, you won't be automatically applied to the standard Affiliate Program. However, you can apply for the program anytime later.",
	"account.setup.skipStep": "Skip step",
	"account.setup.step.about.label.creatorName": "Publisher Name",
	"account.setup.step.about.title": "Affiliate focus",
	"account.setup.step.verification.title": "Billing information",
	"account.setup.stepBackground.label.country": "Which country do you have the largest reach in?",
	"account.setup.stepBackground.label.skillLevel": "How would you rate your skill level?",
	"account.setup.stepBackground.option.beginner": "Beginner",
	"account.setup.stepBackground.option.experienced": "Experienced",
	"account.setup.stepBackground.option.professional": "Professional",
	"account.setup.stepBackground.title": "Reach & Experience",
	"account.setup.stepBillingPayout.payout.title": "Payout via",
	"account.setup.stepChannels.title": "Platform",
	"account.setup.stepGeneral.label.creatorName": "What is your account name?",
	"account.setup.stepGeneral.label.selfDescription": "How would you describe yourself or your content?",
	"account.setup.stepGeneral.placeholder.creatorName": "Enter account name",
	"account.setup.stepGeneral.placeholder.selfDescription": "Describe yourself or your content",
	"account.setup.stepGeneral.title": "About you",
	"account.setup.subtitle": "{name}, you’re almost there!",
	"account.setup.success.button": "Go to dashboard",
	"account.setup.success.nextSteps": "Even if you are not yet approved, you can already familiarize yourself with the tool.",
	"account.setup.success.subtitle": "Your application for the {programme} program has been submitted.",
	"account.setup.success.title": "Account setup complete!",
	"account.setup.title": "Account setup",
	"account.setup.verification.title": "Billing address",
	"account.socialMedia.label.channelUri": "Channel URL",
	"account.socialMedia.label.channelUri.other": "Website URL",
	"account.socialMedia.label.handle": "Channel name",
	"account.socialMedia.label.handle.other": "Name",
	"account.socialMedia.label.mainChannel": "Primary channel",
	"account.socialMedia.label.reach": "Reach",
	"account.socialMedia.label.reachCount": "Followers",
	"account.socialMedia.label.reachCount.other": "Unique monthly visitors",
	"account.socialMedia.label.reachCount.youtube": "Subscribers",
	"account.socialMedia.label.tags": "Content tags",
	"account.socialMedia.noEntryNote": "Add your first channel or website now",
	"account.thomannAffiliatePage.button": "Connect Account",
	"account.thomannAffiliatePage.description": "To generate affiliate links or create a landing page directly in the Thomann shop, link your Clickfire account to your Thomann account.",
	"account.thomannAffiliatePage.label": "Connect your Thomann account",
	"account.thomannAffiliatePage.notApprovedYet": "It is not yet possible to link your Thomann account because you have not yet been approved for the partner program.",
	"affiliateCard.button.details": "View details",
	"affiliateCard.button.message": "Message",
	"affiliateCard.noChannelsData": "The affiliate has not provided any channel information",
	"alert.campaign.notAvailableInYourLanguage": "This campaign is not available in your selected language ({0}). Please keep this in mind when submitting.",
	"alert.dashboard.noProgrammeAssignement": "Welcome to Clickfire. You haven’t applied for any affiliate program yet. Take a look at the {link} to get started right away.",
	"alert.dashboard.noProgrammeAssignement.link": "available programmes",
	"alert.mfa.active.title": "Multi-Factor Authentication is Enabled",
	"alert.mfa.unverified.title": "Multi-Factor Authentication Not Yet Completed",
	"alert.mfaSetup.enrollmentError.description": "Please enter the verification code from your authenticator app.",
	"alert.password.managedExternally": "Your account is managed by {0}. You can only change your password there.",
	"alert.paymentSettingsConflicting": "Update billing information",
	"alert.paymentSettingsMissing": "Add billing information",
	"alert.payout.dataIssue.description": "Your payment details appear to be incomplete or incorrect. Please review and update them to ensure your payouts are processed without issues.",
	"alert.payout.dataIssue.title": "Review your payment details",
	"alert.productreport.fetchError.description": "Unfortunately, we can't load your product report for the selected period because the amount of data is too large. We are working on a solution! In the meantime, please try a smaller time period.",
	"alert.topProductsWidget.error.title": "Error Loading Data",
	"application.noApplications.title": "No Applications Available",
	"applications.label.onlyShowOpenApplications": "Only Show Open Applications",
	"badge.error.campaignDuration": "Duration",
	"badge.error.compensationInEur": "Compensation",
	"badge.error.language": "Language",
	"badge.error.requirements.minSubscribers": "Reach",
	"badge.error.requirements.targetCountry": "Target Country",
	"badge.error.thumbnail": "Thumbnail",
	"badge.new": "new",
	"banner.v1Migration.link": "Sign in here once with your account!",
	"banner.v1Migration.text": "Coming from the old Clickfire?",
	"button.accept": "Accept",
	"button.acceptApplication": "Accept",
	"button.addChannel": "Add channel",
	"button.addMorePlatforms": "Add more platforms",
	"button.addPrimaryPlatform": "Add primary platform",
	"button.addSelection": "Add Selection",
	"button.addUserOrSegmentsForCampaignVisibility": "Add Creator/Creator Segments",
	"button.alreadyAppliedToProgramme": "Applied",
	"button.alreadyHaveAnClickfireAccount": "Already have an account? Click here to log in.",
	"button.applyToCampaign": "Apply",
	"button.applyToProgramme": "Apply to program",
	"button.archived": "Archive",
	"button.backToHome": "Back to home",
	"button.backToLogin": "Back to login",
	"button.backToOverview": "Back to Overview",
	"button.backToPogrammes": "Back to program overview",
	"button.backToSignup": "Back to sign-up",
	"button.cancel": "Cancel",
	"button.changeBillingData": "Change billing information",
	"button.changePassword": "Change password",
	"button.changePaymentInformation": "Change payment information",
	"button.close": "Close",
	"button.completeMfa": "Complete Process",
	"button.confirm": "Confirm",
	"button.confirmSignupOtp": "Verify code",
	"button.contact": "Contact",
	"button.continueInDraftMode": "Continue as Draft",
	"button.copied": "Copied",
	"button.copyCode": "Copy code",
	"button.copyLink": "Copy link",
	"button.createCampaign": "Create campaign",
	"button.creatorPreview": "Creator Preview",
	"button.delete": "Delete",
	"button.deleteCreatorFromSegment": "Remove Creator",
	"button.deleteTranslation": "Delete Language",
	"button.deny": "Deny",
	"button.details": "Details",
	"button.discard": "Discard",
	"button.download": "Download",
	"button.downloadBannerCreative": "Download Banner Creative",
	"button.downloadCsv": "Download .csv",
	"button.edit": "Edit",
	"button.editCampaign": "Edit Campaign",
	"button.editLink": "Edit tracking link",
	"button.filter": "Filter",
	"button.forgotPassword": "Forgot password?",
	"button.generatePersonalizedTrackingLink": "Generate tracking link",
	"button.goBackToClickReport": "back to click report",
	"button.goBackToConversionReport": "Back to conversion report",
	"button.goToCampaign": "View Campaign",
	"button.goToDetails": "View details",
	"button.goToLogin": "Go to login",
	"button.grantAccess": "Grant access",
	"button.hideChannels": "Hide Channels",
	"button.imprint": "Imprint",
	"button.login": "Login",
	"button.loginWithGoogle": "Sign in with Google",
	"button.logout": "Logout",
	"button.lookupApplications": "View Applications",
	"button.lookupSubmissionContentUrl": "Check Submission",
	"button.lookupSubmissions": "Manage Submissions",
	"button.makeCampaignPrivate": "Set to Private",
	"button.makeCampaignPublic": "Set to Public",
	"button.manageSubmissions": "Manage submissions",
	"button.nextStep": "Next Step",
	"button.noAccountSignup": "No account yet? Sign up here!",
	"button.onlyShowMatches": "Show only matches",
	"button.openSubmissionDetails": "Submission Details",
	"button.personalizeLink": "Personalize tracking link",
	"button.privacyPolicy": "Privacy policy",
	"button.publishDraftCampaign": "Publish Campaign",
	"button.removeMfa": "Remove Authenticator App",
	"button.resendContent": "Resubmit Content",
	"button.resetAllFilter": "Reset all filters",
	"button.resetPassword": "Reset password",
	"button.retryApplicationFlow": "Try again",
	"button.reviewSubmission": "View submissions",
	"button.revokeAccess": "Revoke access",
	"button.save": "Save",
	"button.saveAsDraft": "Save as Draft",
	"button.saveCampaignChanges": "Save Campaign",
	"button.saveChanges": "Save changes",
	"button.savePassword": "Save password",
	"button.send": "Submit",
	"button.sendMigrationConformation": "Send verification code",
	"button.sendSubmission": "Submit",
	"button.setupMfa": "Set Up Authenticator App",
	"button.showAllChannels": "Show All Channels",
	"button.showAllResults": "Show all results",
	"button.showMore": "Show more",
	"button.showMoreChannels": "+ {0} more channels",
	"button.signupNow": "Sign up now",
	"button.signupWithGoogle": "Sign up with Google",
	"button.submitVideo": "Submit video",
	"button.toDashboard": "Go to dashboard",
	"button.toMerchantSelection": "To Merchant Selection",
	"button.toTransmittal": "Go to submission",
	"button.tos": "Terms & Conditions",
	"button.translateContentWithAi": "Translate Content with AI",
	"button.uploadAvatar": "Upload avatar",
	"button.uploadImage": "Upload new image",
	"button.verifyMfa": "Verify Code",
	"campaign.admin.applicationState.accepted": "Accepted",
	"campaign.admin.applicationState.open": "Open",
	"campaign.admin.applicationState.rejected": "Rejected",
	"campaign.admin.badge.visibility.private": "Private",
	"campaign.applicationState.accepted": "Application Accepted",
	"campaign.applicationState.open": "Applied",
	"campaign.applicationState.rejected": "Application Rejected",
	"campaign.badge.openApplications": "Unchecked Applications",
	"campaign.badge.unapprovedSubmissions": "Unchecked Submissions",
	"campaign.badge.visibility.private": "Exclusive",
	"campaign.badge.visibility.public": "Public",
	"campaign.badge.wasActiveFor": "Was Active for {0} Days",
	"campaign.daysRemaining": "Expires in {count} Day | Expires in {count} Days",
	"campaign.durationExceeded": "Expired",
	"campaign.property.category": "Category",
	"campaign.property.compensation": "Compensation",
	"campaign.property.createdAt": "Created at",
	"campaign.property.cta": "CTA",
	"campaign.property.description": "Description",
	"campaign.property.keyMessage": "Key Message",
	"campaign.property.requirements": "Requirements",
	"campaign.property.restrictions": "Prohibitions",
	"campaign.property.videoRequirements": "Video requirements",
	"campaignHistoricStatus.acceptedNoSubmission": "Accepted – Pending",
	"campaignHistoricStatus.applicationPending": "Applied",
	"campaignHistoricStatus.applicationRejected": "Application rejected",
	"campaignHistoricStatus.contentApproved": "Content approved",
	"campaignHistoricStatus.contentRejected": "Content rejected",
	"campaignHistoricStatus.contentSubmitted": "Content submitted",
	"campaignType.article": "Blog Post / Website Article",
	"campaignType.bundle": "Content Package",
	"campaignType.shortVideo": "Short Video",
	"campaignType.sparkAd": "SparkAd",
	"campaignType.sponsoredSegment": "Sponsored YouTube Segment",
	"campaignVisibility.placehoder": "Select Creator or Creator Segments",
	"createProgrammeLinkForm.subtitle": "Create a custom link",
	"createProgrammeLinkForm.title": "Tracking link creation",
	"dashboard.widget.commissions.link": "Payouts",
	"dashboard.widget.conversions.link": "Conversion report",
	"dashboard.widget.topSeller.link": "Product report",
	"days": "0 days | 1 day | {count} days",
	"description.campaignName": "The name is for your internal purposes only and will not be shown to affiliates",
	"description.campaignVisibility": "You can exclusively release and display your campaign only for specific Creators or Creator Segments.",
	"description.noVisibilitySettingsYet": "Your campaign is currently not visible to anyone. Add Creators or Creator Segments to make your campaign visible or set it to public.",
	"error.fetch.description": "An unknown error has occurred. Please try again later.",
	"error.fetch.title": "Error Loading Data",
	"error.maxDate": "The latest possible date is {date}",
	"error.minDate": "The earliest possible date is {date}",
	"error.noAdmin.subtitle": "You don’t have the necessary permission to view this area. Try logging in with another account.",
	"error.noAdmin.title": "Access denied!",
	"error.noMerchantAccess.otherMerchants.subtitle": "Unfortunately, you do not have access to this merchant. However, we can forward you to one of the merchants for which you have been approved.",
	"error.noMerchantAccess.subtitle": "Unfortunately, you do not have access to this merchant.",
	"error.noMerchantAccess.title": "Access denied",
	"error.noValidDateFormat": "Invalid date format",
	"error.rejectedByMerchant.subtitle": "We have sent you further information via email. We ask for your understanding.",
	"error.rejectedByMerchant.title": "Unfortunately, your application was rejected",
	"error.signInWithOtp": "The confirmation code you entered is invalid. Please check your entry.",
	"filter.alltime": "All Time",
	"filter.conversionStatus.all": "All",
	"filter.conversionStatus.notRejected": "Excluding rejected",
	"filter.filterOptions": "Filter options",
	"filter.lastDays": "Last day | Last {count} days",
	"filter.monthRange": "Last month | Last {count} months",
	"filter.price.max": "Max. price",
	"filter.price.min": "Min. price",
	"filter.provisionGroups.all": "All provision groups",
	"filter.thisMonth": "This Month",
	"filter.thisYear": "This Year",
	"filter.yearRange": "Last Year | Last {count} Years",
	"footer.links.v1signin": "Switch to v1",
	"intervalType.halfYear": "Semi-annual",
	"intervalType.monthly": "Monthly",
	"intervalType.quarterYear": "Quarterly",
	"intervalType.year": "Yearly",
	"label.accessBlocked": "Access blocked",
	"label.accessGranted": "Access granted",
	"label.affiliateType.cashback": "Cashback",
	"label.affiliateType.display": "Display ads",
	"label.affiliateType.influencer": "Influencer",
	"label.affiliateType.loyalty": "Loyalty",
	"label.affiliateType.other": "Other",
	"label.affiliateType.priceComparisonEngine": "Price comparison engine",
	"label.affiliateType.search": "Search ads",
	"label.affiliateType.website": "Website / Content",
	"label.affiliates.count": "Partners",
	"label.amountInSecondsShort": "{0}sec",
	"label.applications.open.total": "Open Applications",
	"label.archived": "Archived",
	"label.averageCartValue": "⌀ Cart value",
	"label.calendarWeekShort": "CW",
	"label.campaignDuration": "Campaign End",
	"label.campaignName": "Campaign Name",
	"label.campaignType": "Campaign Type",
	"label.campaignVisibility": "Restrict Visibility",
	"label.clicks.count": "Clicks",
	"label.columns": "Columns",
	"label.comissionRate": "Commission rate",
	"label.comissionType": "Commission type",
	"label.commissionAmountRange": "Commission range",
	"label.comparisonPeriod": "Comparison period",
	"label.compensationInEur": "Compensation (Fixed Amount in €)",
	"label.contentLength": "Content Length",
	"label.contentTags": "Content tags",
	"label.conversion.payout": "Commission",
	"label.conversions": "Conversions",
	"label.conversions.displayMode.single": "Individual conversions",
	"label.conversions.displayMode.weekly": "Weekly summary",
	"label.country": "Country",
	"label.currentPeriod": "Current period",
	"label.customDateRange": "Custom",
	"label.dateRange.comparedTo": "{range} · compared to {comparison}",
	"label.dateRange.since": "Since {0}",
	"label.dateRange.until": "Until {0}",
	"label.deltaShort": "Δ",
	"label.description": "Description",
	"label.draft": "Entwurf",
	"label.durationRemaining": "Remaining Duration",
	"label.emailShort": "Email",
	"label.groupingIntervalOption.date": "Days",
	"label.groupingIntervalOption.month": "Months",
	"label.groupingIntervalOption.week": "Weeks",
	"label.heardAboutSource.email": "Email",
	"label.heardAboutSource.google": "Google",
	"label.heardAboutSource.notSpecified": "Not specified",
	"label.heardAboutSource.otherSource": "Other source",
	"label.heardAboutSource.personalInvitation": "Personal invitation",
	"label.heardAboutSource.recommendation": "Recommendation",
	"label.id": "ID",
	"label.inactive": "Inactive",
	"label.individual": "Choose individually",
	"label.language": "Language",
	"label.languages": "Languages",
	"label.lastMonths": "of the last {0} months",
	"label.lensGrouping.country": "By Country",
	"label.lensGrouping.group": "By Provision Group",
	"label.lensGrouping.publisher": "All Partners",
	"label.month": "Month",
	"label.netSumRange": "Revenue (net)",
	"label.networkAccess": "Network access",
	"label.noProgramme": "Without programme",
	"label.noSales": "No sales",
	"label.noVisibilitySettingsYet": "Your campaign is invisible",
	"label.openApplications": "Applications",
	"label.openApplicationsWithCount": "1 Application | {count} Applications",
	"label.openSubmissionsWithCount": "1 Submission | {count} Submissions",
	"label.others": "Others",
	"label.partner": "Partner",
	"label.payoutFrom": "from {value}",
	"label.payoutRange": "Payout range",
	"label.performance": "Performance",
	"label.performanceIndex": "Performance Index",
	"label.period": "Period",
	"label.platform": "Platform",
	"label.platforms": "Platforms",
	"label.previousPeriod": "Previous period",
	"label.primaryPlatform": "Primary platform",
	"label.programme": "Program",
	"label.programmeAffiliation": "Programme affiliation",
	"label.programmeApplicationState": "Application Status",
	"label.provisionGroup": "Provision Group",
	"label.publisherId": "Publisher ID",
	"label.publisherIdShort": "ID",
	"label.rankShort": "#",
	"label.reach": "Reach",
	"label.reach.none": "None",
	"label.referrerBonus": "Referrer-Bonus",
	"label.rejectionReason": "Rejection reason",
	"label.requirements.minSubscribers": "Minimum Reach",
	"label.requirements.targetCountry": "Target Country / Countries",
	"label.revenue": "Revenue",
	"label.revenueLastDays": "Revenue in the last {0} days",
	"label.saleAmountRange": "Sale amount range",
	"label.salesValue": "Sales Value",
	"label.salesValueShare": "Sales Value share",
	"label.search": "Search...",
	"label.searchScope.ariaLabel": "Select search field",
	"label.searchScope.company": "Company",
	"label.searchScope.conversionId": "Conversion ID",
	"label.searchScope.email": "E-Mail",
	"label.searchScope.handle": "Channel name",
	"label.searchScope.ignoredTerms": "Ignored, not a valid {label}: {terms}",
	"label.searchScope.invoiceNumber": "Credit note number",
	"label.searchScope.name": "Name",
	"label.searchScope.orderNumber": "Order number",
	"label.searchScope.placeholder": "Search by {label}...",
	"label.searchScope.publisherId": "Publisher ID",
	"label.searchScope.subId1": "Sub ID 1",
	"label.searchScope.subId2": "Sub ID 2",
	"label.selectComparisonPeriod": "Select comparison period",
	"label.selectPeriod": "Select period",
	"label.selected": "{0} selected",
	"label.sortAscending": "Sorted ascending",
	"label.sortByLong": "Sort by:",
	"label.sortDescending": "Sorted descending",
	"label.thumbnail.format": "Format",
	"label.thumbnail.size": "Size",
	"label.thumbnail.size.atLeast": "at least {0}",
	"label.totalCreators": "Creators",
	"label.totalParticipants": "Participants",
	"label.weekOfDate": "Week of {0}",
	"label.withProgramme": "With programme",
	"label.withSales": "With sales",
	"label.withoutPending": "Confirmed",
	"label.workInProgress": "Work in progress",
	"label.yAxisScaleOption.linear": "Linear",
	"label.yAxisScaleOption.logarithmic": "Logarithmic",
	"label.year": "Year",
	"label.yourCreativeLink": "Creative link",
	"label.yourLink": "Personalized tracking link",
	"label.yourPublisherId": "Affiliate ID (affid)",
	"label.yoy": "YoY",
	"language.english": "English",
	"language.german": "German",
	"link.imprint": "https://clickfire.io/en/imprint",
	"link.privacyPolicy": "https://clickfire.io/en/data-protection",
	"link.tos": "https://clickfire.io/en/terms-of-service",
	"modal.billingData.label.city": "City",
	"modal.billingData.label.companyName": "Company (optional)",
	"modal.billingData.label.country": "Country",
	"modal.billingData.label.firstName": "First name",
	"modal.billingData.label.lastName": "Last name",
	"modal.billingData.label.postalCode": "Postal code",
	"modal.billingData.label.street": "Street",
	"modal.campaignApplicationSuccess.title": "Application Successfully Submitted",
	"modal.campaignCreated.draft.title": "Draft Successfully Created!",
	"modal.campaignCreated.title": "Campaign Successfully Created!",
	"modal.cropImage.button.cancel": "Cancel",
	"modal.cropImage.button.confirm": "Apply",
	"modal.cropImage.button.reset": "Reset",
	"modal.cropImage.title": "Edit Image",
	"modal.deleteCampaign.description": "Are you sure you want to delete this campaign?",
	"modal.deleteCampaign.title": "Delete draft",
	"modal.downloadCsv.badge.hasAnyFilterActive": "Filter active",
	"modal.downloadCsv.description": "You can generate a CSV file for your report. All currently active filters will be applied. Depending on the amount of data, the creation may take a moment.",
	"modal.downloadCsv.title": "Download Report as CSV",
	"modal.mfaSetup.description": "Scan the QR code with your authenticator app or enter the code manually. After successful setup, you must enter the PIN directly here to complete the process.",
	"modal.mfaSetup.factorSecretCode.description": "Use this code if you have difficulties with the QR code",
	"modal.mfaSetup.factorSecretCode.title": "Secret Code",
	"modal.mfaSetup.title": "Set Up Multi-Factor Authentication",
	"modal.newPassword.label.password": "New password",
	"modal.newPassword.label.passwordConfirm": "Confirm new password",
	"modal.newSegment.button.cancel": "Cancel",
	"modal.newSegment.button.confirm": "Create",
	"modal.newSegment.description": "What would you like to name the new Creator Segment?",
	"modal.newSegment.input.placeholder": "Give your new Creator Segment a name",
	"modal.newSegment.title": "Create New Creator Segment",
	"modal.outdatedBrowser.button": "Ignore message",
	"modal.outdatedBrowser.description": "You are using an old browser version that Clickfire no longer supports. To use our app without problems, please update to a current version.",
	"modal.outdatedBrowser.title": "Your browser is outdated",
	"modal.paymentInformation.label.accountHolder": "Account holder",
	"modal.paymentInformation.label.bankName": "Bank name",
	"modal.paymentInformation.label.bic": "BIC",
	"modal.paymentInformation.label.emailAdress": "Email address",
	"modal.paymentInformation.label.iban": "IBAN",
	"modal.paymentInformation.label.paymentType": "Payment method",
	"modal.programmeApplication.button.confirm": "Okay, got it!",
	"modal.programmeApplication.rejected.note": "If you meet the requirements at a later date, you can contact support to re-apply for the program",
	"modal.programmeApplication.rejected.reason.general.title": "Your application for \"{0}\" was rejected.",
	"modal.programmeApplication.rejected.reason.policy.title": "Your application for \"{0}\" was rejected due to the Affiliate Policy.",
	"modal.programmeApplication.rejected.reason.reach.title": "Your application for \"{0}\" was rejected due to insufficient reach.",
	"modal.programmeApplication.rejected.reason.topic.title": "Your application for \"{0}\" was rejected due to irrelevant content/topic.",
	"modal.removeMfaConfirmation.cancelLabel": "Cancel",
	"modal.removeMfaConfirmation.confirmLabel": "Okay",
	"modal.removeMfaConfirmation.description": "Are you sure you want to remove your authenticator app?",
	"modal.removeMfaConfirmation.title": "Remove Authenticator App",
	"modal.segmentCreatorPreview.title": "All Creators of Segment \"{0}\"",
	"modal.selectProvisionGroup.button.confirm": "Grant Access",
	"modal.selectProvisionGroup.description": "A provision group must be assigned to grant programme access. Please select a provision group.",
	"modal.selectProvisionGroup.placeholder": "Select provision group",
	"modal.selectProvisionGroup.title": "Provision Group Required",
	"modal.selectRejectionReasons.title": "Rejection Reason",
	"modal.submissionLinks.title": "Submissions from {0}",
	"modal.submissions.approved.subtitle": "The transfer of the credit will occur with the next payout cycle",
	"modal.submissions.approved.title": "Your Submission Has Been Accepted",
	"modal.submissions.button.addContentUrl": "Add URL",
	"modal.submissions.exceeded.subtitle": "The campaign is unfortunately no longer active.",
	"modal.submissions.exceeded.title": "Submission No Longer Possible",
	"modal.submissions.goToFaq": "Need Help? {link}",
	"modal.submissions.goToFaq.link": "Go to FAQ",
	"modal.submissions.label.confirmTos": "By agreeing to the Terms and Conditions, you establish a contract between you, {merchant} and Clickfire. {link}",
	"modal.submissions.label.confirmTos.link": "See Terms and Conditions for Details",
	"modal.submissions.label.contentUrl": "Content URL",
	"modal.submissions.label.videoUrl": "Video URL",
	"modal.submissions.missing.subtitle": "Please note the campaign guidelines",
	"modal.submissions.missing.title": "We Look Forward to Your Content!",
	"modal.submissions.rejected.subtitle": "You can submit a new entry if you have adjusted your content.",
	"modal.submissions.rejected.title": "Your Submission Has Been Rejected",
	"modal.submissions.submitted.subtitle": "Processing your submissions takes an average of 3-5 days",
	"modal.submissions.submitted.title": "Your Submission Is Being Processed",
	"modal.success.subtitle.splitOne": "Please be patient until",
	"modal.success.subtitle.splitTwo": " the video has been reviewed. In the meantime, you can also track your submission status.",
	"modal.success.title": "Thank you for your submission",
	"modal.tiptaplink.button.delete": "Delete",
	"modal.tiptaplink.button.submit": "Save",
	"modal.tiptaplink.title": "Add Link",
	"modal.uncopiedLink.cancelLabel": "Stay on page",
	"modal.uncopiedLink.confirmLabel": "Program overview",
	"modal.uncopiedLink.description": "You haven’t copied a link yet!",
	"modal.uncopiedLink.title": "Do you really want to leave the page?",
	"modal.unsavedChanges.cancelLabel": "Back",
	"modal.unsavedChanges.confirmLabel": "Don’t save",
	"modal.unsavedChanges.description": "Are you sure you want to leave without saving?",
	"modal.unsavedChanges.title": "Warning: Unsaved changes",
	"note.aboutConversionsData": "Rejected conversions are not shown",
	"note.aboutNewReportDataLatency": "It can take up to 5 minutes for new data to be displayed",
	"page.account.applicationAndChannels.title": "Application Data & Channels",
	"page.account.heading": "Your Profile",
	"page.account.merchant.title": "Application details",
	"page.account.password.section.changePassword.title": "Change Password",
	"page.account.password.section.mfa.description": "Setting up an authenticator app is a great way to add an extra layer of security to your Clickfire account, ensuring that only you can log in.",
	"page.account.password.section.mfa.title": "Multi-Factor Authentication",
	"page.account.payment.section.payment.title": "Payment Information",
	"page.account.payment.section.publisherData.title": "Billing Details",
	"page.account.payment.title": "Billing & Payment Details",
	"page.account.socialMedia.title": "Channels",
	"page.account.title": "Account",
	"page.account.uploadAvatar.requirements1": "min. 500x500px",
	"page.account.uploadAvatar.requirements2": "format: png or jpg",
	"page.account.widget.passwordAndSecurity.title": "Password & Security",
	"page.admin.affiliate.misc.customTrackingParameters": "Custom tracking parameters",
	"page.admin.affiliate.misc.emailAddressInvoice": "Email address for credit notes",
	"page.admin.affiliate.misc.emailNotificationOnInvoice": "Email notification on credit note",
	"page.admin.affiliate.misc.emailNotificationOnSale": "Email notification on sale",
	"page.admin.affiliate.misc.language": "Language for email communication",
	"page.admin.affiliate.misc.rejectConversions": "Reject all conversions",
	"page.admin.affiliate.misc.skipInvoiceCreation": "Skip invoice creation",
	"page.admin.affiliate.misc.skipSepaExport": "Skip SEPA export",
	"page.admin.affiliate.misc.smallBusinessRegulationAffected": "Small business regulation",
	"page.admin.affiliate.misc.taxConfirmationSupplied": "Tax confirmation supplied",
	"page.admin.affiliate.notFound": "Affiliate Not Found",
	"page.admin.affiliate.unsavedChanges": "You have unsaved changes",
	"page.admin.affiliate.widget.applicationData.title": "Application Data",
	"page.admin.affiliate.widget.billingAndTaxes.title": "Billing & Taxes",
	"page.admin.affiliate.widget.billingData.title": "Billing Address",
	"page.admin.affiliate.widget.channels.title": "Channels",
	"page.admin.affiliate.widget.creatorProfile.title": "Creator Profile",
	"page.admin.affiliate.widget.individualPayout.noAccess": "The individual payout can only be configured once the user has access to this programme.",
	"page.admin.affiliate.widget.individualPayout.noProvisionGroup": "An individual payout can only be set once a provision group has been assigned.",
	"page.admin.affiliate.widget.individualPayout.override.description": "Overrides the default payout of the assigned provision group for this programme.",
	"page.admin.affiliate.widget.individualPayout.override.label": "Override individual payout for this programme",
	"page.admin.affiliate.widget.individualPayout.title": "Individual Payout",
	"page.admin.affiliate.widget.masterData.title": "Master Data",
	"page.admin.affiliate.widget.misc.title": "Miscellaneous",
	"page.admin.affiliate.widget.paymentInfo.title": "Payment Information",
	"page.admin.affiliate.widget.pecHistory.omitRejected": "Hide rejected applications",
	"page.admin.affiliate.widget.pecHistory.title": "Campaign overview",
	"page.admin.affiliate.widget.productFeedRegistrations.title": "Product Feed Registrations",
	"page.admin.affiliate.widget.programmeApplications.title": "Programme & Campaign Approvals",
	"page.admin.affiliate.widget.programmes.button.grantAccess": "Grant programme access",
	"page.admin.affiliate.widget.programmes.button.hold": "Put on hold",
	"page.admin.affiliate.widget.programmes.button.resume": "Reactivate",
	"page.admin.affiliate.widget.programmes.button.revokeAccess": "Revoke programme access",
	"page.admin.affiliate.widget.provisionGroups.placeholder": "Select provision group",
	"page.admin.affiliate.widget.provisionGroups.title": "Provision Group",
	"page.admin.affiliate.widget.urlReferrer.title": "URL Referrer",
	"page.admin.applications.history.title": "Application History",
	"page.admin.applications.label.onlyShowOpenApplications": "Hide deferred applications",
	"page.admin.applications.title": "Application Overview",
	"page.admin.campaign.applications.title": "Applications",
	"page.admin.campaign.apply.card.label.codeDuration": "Code validity",
	"page.admin.campaign.apply.card.label.videoCode": "Video code",
	"page.admin.campaign.apply.steps.stepFive.alert.description": "If you want the authorized post to appear only in TikTok ads and not in the “For You” feed, follower feed, your profile page, search results, or playlist, enable “Deliver in ads only” in the ad settings. This feature is available from TikTok version 21.3 onward.",
	"page.admin.campaign.apply.steps.stepFive.alert.title": "Note",
	"page.admin.campaign.apply.steps.stepFive.text": "Paste the code into our designated input field.",
	"page.admin.campaign.apply.steps.stepFive.title": "Step 5:",
	"page.admin.campaign.apply.steps.stepFour.listItemOne": "Enable “Anchor Authorization” to allow us to add a link to your video. This step is optional.",
	"page.admin.campaign.apply.steps.stepFour.text": "Enable “Anchor Authorization”.",
	"page.admin.campaign.apply.steps.stepFour.title": "Step 4:",
	"page.admin.campaign.apply.steps.stepOne.text": "Record a video according to the requirements and upload it to TikTok.",
	"page.admin.campaign.apply.steps.stepOne.title": "Step 1:",
	"page.admin.campaign.apply.steps.stepThree.alert.description": "In this view, you can extend the generated code afterward.",
	"page.admin.campaign.apply.steps.stepThree.alert.title": "Note",
	"page.admin.campaign.apply.steps.stepThree.listItemOne": "Select the authorization duration and click “Authorize.” We recommend at least 30 days.",
	"page.admin.campaign.apply.steps.stepThree.listItemThree": "Finally, copy the video code by clicking “Manage”.",
	"page.admin.campaign.apply.steps.stepThree.listItemTwo": "Click “Generate” and then “Save.”",
	"page.admin.campaign.apply.steps.stepThree.text": "Generate the video code.",
	"page.admin.campaign.apply.steps.stepThree.title": "Step 3:",
	"page.admin.campaign.apply.steps.stepTwo.listItemOne": "Open the TikTok video you want to authorize.",
	"page.admin.campaign.apply.steps.stepTwo.listItemThree": "Enable the “Ad Authorization” toggle and agree to the terms.",
	"page.admin.campaign.apply.steps.stepTwo.listItemTwo": "Tap the three dots in the bottom right to open the menu, then select “Ad settings.”",
	"page.admin.campaign.apply.steps.stepTwo.text": "Authorize the video in the TikTok app for advertising purposes.",
	"page.admin.campaign.apply.steps.stepTwo.title": "Step 2:",
	"page.admin.campaign.apply.steps.title": "How to generate a video code?",
	"page.admin.campaign.apply.title.partOne": "Submit video for",
	"page.admin.campaign.apply.title.partTwo": "submit",
	"page.admin.campaign.archived": "Archived",
	"page.admin.campaign.description": "Description",
	"page.admin.campaign.noCampaigns.subtitle": "Create a campaign so your affiliates can create content.",
	"page.admin.campaign.noCampaigns.title": "No Active Campaigns",
	"page.admin.campaign.notFound": "Campaign Not Found",
	"page.admin.campaign.requirements": "Requirements",
	"page.admin.campaign.submissions.backToCampaign": "Back to campaign",
	"page.admin.campaign.submissions.title": "Submissions",
	"page.admin.campaign.submissions.transimittals": "Submissions",
	"page.admin.campaign.videoRequirements": "Video requirements",
	"page.admin.campaigns.active.title": "Active Campaigns",
	"page.admin.campaigns.alert.disallowAdvancedEditing": "Affiliates have already applied to your campaign. Therefore, not all details can be edited.",
	"page.admin.campaigns.button.addRequirement": "Add Requirement",
	"page.admin.campaigns.button.addRestriction": "Add Prohibition",
	"page.admin.campaigns.button.createCampaign": "Create Campaign",
	"page.admin.campaigns.createNewCampaign": "Create new campaign",
	"page.admin.campaigns.editCampaign": "Edit Campaign",
	"page.admin.campaigns.label.campaignTitle": "Campaign title",
	"page.admin.campaigns.label.compensationInEuro": "Compensation (in €)",
	"page.admin.campaigns.label.description": "Description",
	"page.admin.campaigns.label.endOfCampaign": "End of campaign",
	"page.admin.campaigns.label.noLanguages": "Add the first language for your new campaign now",
	"page.admin.campaigns.label.thumbnail": "Thumbnail",
	"page.admin.campaigns.label.uProductOrCategory": "Product/Category",
	"page.admin.campaigns.newCampaign": "New campaign",
	"page.admin.campaigns.plusCreateCampaign": "+ Create campaign",
	"page.admin.dashboard.cards.activeCampaigns.linkLabel": "Show active campaigns",
	"page.admin.dashboard.cards.activeCampaigns.title": "Active campaigns",
	"page.admin.dashboard.cards.openSubmission.linkLabel": "Show submissions",
	"page.admin.dashboard.cards.openSubmission.title": "Open submissions",
	"page.admin.dashboard.cards.payouts.linkLabel": "Show past payouts",
	"page.admin.dashboard.cards.payouts.title": "Outstanding balance",
	"page.admin.dashboard.dataFreshness": "Data is updated every 6 hours. Last update ~{elapsed} ago.",
	"page.admin.dashboard.headline": "{merchant} Dashboard",
	"page.admin.dashboard.widget.campaignTodos.label.openApplications": "Open applications",
	"page.admin.dashboard.widget.campaignTodos.label.openSubmissions": "Submissions",
	"page.admin.dashboard.widget.campaignTodos.title": "Campaign To-Dos",
	"page.admin.dashboard.widget.networkActivity.label.active": "Active with conversions",
	"page.admin.dashboard.widget.networkActivity.label.newPartnersWithoutClick": "New partners without click",
	"page.admin.dashboard.widget.networkActivity.label.newPartnersWithoutConversion": "New partners without conversion",
	"page.admin.dashboard.widget.networkActivity.title": "Network Activity",
	"page.admin.dashboard.widget.networkByCountry.title": "Network by Country",
	"page.admin.dashboard.widget.programmeTodos.label.openApplications": "Open applications",
	"page.admin.dashboard.widget.programmeTodos.label.openConversions": "Conversions under review",
	"page.admin.dashboard.widget.programmeTodos.title": "Programme To-Dos",
	"page.admin.dashboard.widget.provisionGroups.title": "Provision Groups",
	"page.admin.dashboard.widget.topPerformers.label.allCountries": "All countries",
	"page.admin.dashboard.widget.topPerformers.label.allProvisionGroups": "All provision groups",
	"page.admin.dashboard.widget.topPerformers.label.byCountry": "By country",
	"page.admin.dashboard.widget.topPerformers.label.byProvisionGroup": "By provision group",
	"page.admin.dashboard.widget.topPerformers.title": "Top Performers",
	"page.admin.domains.empty.description": "You're all caught up! New registrations will appear here as soon as they come in.",
	"page.admin.domains.empty.title": "No domain registrations",
	"page.admin.domains.openRegistrations": "Open domain registrations",
	"page.admin.domains.title": "Domains",
	"page.admin.merchant.viewTitle": "Hello",
	"page.admin.merchants.availableMerchants": "Available merchants",
	"page.admin.merchants.dashboard.title": "Merchant dashboard",
	"page.admin.merchants.submissions.title": "Submissions from",
	"page.admin.merchants.title": "Admin merchant selection",
	"page.admin.partnerReport.title": "Network Report",
	"page.admin.payouts.payouts": "Payouts",
	"page.admin.programmeApplications.history.noApplications.description": "Once you have processed an application, it will be displayed here",
	"page.admin.programmeApplications.history.noApplications.title": "No applications available",
	"page.admin.programmeApplications.noApplications.description": "You've processed everything! As soon as there are new applications, they will be shown here",
	"page.admin.programmeApplications.noApplications.title": "No applications available",
	"page.admin.segment.addCreators": "Add Creators",
	"page.admin.segment.goBackToOverview": "Back to all Creator Segments",
	"page.admin.segment.section.campaigns.noCampaigns.description": "This Creator Segment is currently not used for restricted visibility in any active campaign.",
	"page.admin.segment.section.campaigns.noCampaigns.title": "No Campaigns",
	"page.admin.segment.section.campaigns.title": "Visible Campaigns",
	"page.admin.segment.section.creators.title": "User List",
	"page.admin.segments.createSegment": "Create Creator Segment",
	"page.admin.segments.noSegments.subtitle": "Create your first group of Creators.",
	"page.admin.segments.noSegments.title": "No Creator Segments",
	"page.admin.segments.title": "Creator Segments",
	"page.admin.submissions.allTransmittals": "All submissions",
	"page.admin.submissions.category": "Category",
	"page.admin.submissions.compensation": "Compensation",
	"page.admin.submissions.dateOfTransmittal": "Submission date",
	"page.admin.submissions.helpfulLinks": "Helpful links",
	"page.admin.submissions.howDoIBookSparkAds": "How do I book Spark Ads in TikTok Ads Manager?",
	"page.admin.submissions.howDoIBookSparkAds.link": "https://ads.tiktok.com/help/article/spark-ads-creation-guide?lang=de#anchor-6",
	"page.admin.submissions.howToGenerateAVideoCode": "How to generate a video code?",
	"page.admin.submissions.periodOfValidity": "Validity period",
	"page.admin.submissions.status": "Status",
	"page.admin.submissions.tikTokCode": "TikTok code",
	"page.admin.submissions.transmittalsOf": "Submissions from",
	"page.admin.submissions.whyShouldIBookSparkAds": "Why should I book Spark Ads?",
	"page.admin.submissions.whyShouldIBookSparkAds.link": "https://ads.tiktok.com/help/article/spark-ads?lang=de",
	"page.affiliate.navigation.details": "Payment & Other",
	"page.affiliate.navigation.overview": "Account Overview",
	"page.affiliate.navigation.programmes": "Programmes",
	"page.affiliates.filter.showAllChannels.label": "Always show all channels",
	"page.affiliates.filter.title": "Filter options",
	"page.affiliates.noMatches": "No matching affiliates found for your search",
	"page.affiliates.showChannelInformation.label": "Show channel information",
	"page.affiliates.single.title": "Affiliate details: {0}",
	"page.affiliates.single.widget.overview.title": "Affiliate partner overview",
	"page.affiliates.title": "Partner overview",
	"page.campaign.archived.title": "The Campaign Has Expired and Is Archived. It Can No Longer Be Edited.",
	"page.campaign.draft.title": "The Campaign Is Not Published. It Is a Draft.",
	"page.campaigns.navigation.applications": "Applications",
	"page.campaigns.navigation.details": "Campaign Details",
	"page.campaigns.navigation.submissions": "Submissions",
	"page.campaigns.navigation.visibility": "Visibility Settings",
	"page.clickDetailSingle.general.title": "General information",
	"page.clickDetailSingle.general.trackingMethod": "Tracking method",
	"page.clickDetailSingle.title": "Click details",
	"page.clickDetailSingle.title.notFound": "Click not found",
	"page.clickDetailSingle.tracking.browser": "Browser",
	"page.clickDetailSingle.tracking.date": "Date / Time",
	"page.clickDetailSingle.tracking.originalReferrer": "Original referrer",
	"page.clickDetailSingle.tracking.programmeUrl": "Programm URL",
	"page.clickDetailSingle.tracking.referrer": "Referrer",
	"page.clickDetailSingle.tracking.title": "Tracking",
	"page.clickDetailSingle.tracking.userAgent": "User-Agent",
	"page.clickReport.realtime.subtitle": "The last {0} clicks of the last 24 hours",
	"page.clickReport.realtime.title": "Realtime Clicks",
	"page.clickReport.title": "Click report",
	"page.confirm.waitForLogin": "Waiting for login...",
	"page.content.notFound": "Page not found",
	"page.conversionSingle.general.click": "Click",
	"page.conversionSingle.general.method": "Tracking method",
	"page.conversionSingle.general.newCustomer": "New customer",
	"page.conversionSingle.general.orderId": "Order ID",
	"page.conversionSingle.general.programmeType": "Program type",
	"page.conversionSingle.general.status": "Status",
	"page.conversionSingle.general.title": "General information",
	"page.conversionSingle.general.type": "Type",
	"page.conversionSingle.payout.currency": "Currency",
	"page.conversionSingle.payout.payout": "Commission",
	"page.conversionSingle.payout.saleAmount": "Sale amount",
	"page.conversionSingle.payout.title": "Commission",
	"page.conversionSingle.title": "Conversion details",
	"page.conversionSingle.title.notFound": "Conversion not found",
	"page.conversionSingle.transactions.title": "Transaction details",
	"page.conversions.cards.commissionReport.subtitle": "of the last {0} months",
	"page.conversions.cards.commissionReport.title": "Commission overview",
	"page.conversions.cards.conversionStatus.subtitle": "of the last {0} weeks",
	"page.conversions.cards.conversionStatus.title": "Conversion status",
	"page.dashboard.cards.lastInvoice.button": "Download invoice",
	"page.dashboard.cards.lastInvoice.label": "Invoice date: {0}",
	"page.dashboard.cards.lastInvoice.title": "Current credit note",
	"page.dashboard.cards.lastPayout.title": "Last payout",
	"page.dashboard.cards.openPayout.title": "Currently open",
	"page.dashboard.title": "Dashboard",
	"page.error.button.backToHome": "Back to home",
	"page.error.critical.title": "An unexpected error occurred",
	"page.error.notFound.title": "404 - Not Found",
	"page.error.pageNotFound.title": "Page Not Found",
	"page.error.support.title": "Oops, something went wrong",
	"page.error.unexpected.withCode": "Error code: {0}",
	"page.login.label.email": "Email address",
	"page.login.label.or": "or",
	"page.login.label.password": "Password",
	"page.login.pageTitle": "Login",
	"page.login.subtitle": "in your {0} affiliate network",
	"page.login.title": "Hi, nice to see you again 😊",
	"page.loginConfirm.waitingForLogin": "You are being logged in...",
	"page.logout.waitingForLogout": "You are being logged out...",
	"page.merchants.availableMerchants.description": "You’re registered for multiple merchants. Please choose one to continue with.",
	"page.merchants.availableMerchants.title": "Merchant selection",
	"page.merchants.campaigns.archivedCampaigns": "Archived campaigns",
	"page.merchants.campaigns.backToOverview": "Back to Overview",
	"page.merchants.campaigns.drafts.title": "Drafts",
	"page.merchants.campaigns.noCampaigns.subtitle": "Soon you will be able to apply for exciting campaigns here. Check back soon.",
	"page.merchants.campaigns.noCampaigns.title": "No Campaigns Available Yet",
	"page.merchants.campaigns.openSubmissions.label": "open submission",
	"page.merchants.campaigns.openSubmissions.label.plural": "open submissions",
	"page.merchants.campaigns.showActiveCampaigns.label": "show active campaigns",
	"page.merchants.campaigns.showArchivedCampaigns.label": "show archived campaigns",
	"page.merchants.campaigns.title": "Available Campaigns",
	"page.merchants.conversions.title": "Conversion report",
	"page.merchants.dashboard.viewTitle": "Welcome back,",
	"page.merchants.noMerchant.description": "You’re not registered with any merchant. To continue with Clickfire, you need to register with a merchant. Go back to your merchant’s website or contact our support.",
	"page.merchants.noMerchant.title": "No merchant found",
	"page.merchants.payouts.title": "Payouts",
	"page.merchants.productReport.title": "Product report",
	"page.merchants.productWidgetDomains.title": "Domain overview",
	"page.merchants.productWidgetEdit.title": "Edit Widget",
	"page.merchants.productWidgetNew.title": "Create Widget",
	"page.merchants.productWidgetPreview.title": "Widget preview",
	"page.merchants.productWidgets.title": "Product Widgets",
	"page.merchants.programme.applicationStatus": "Application status",
	"page.merchants.programme.canApply.1": "You’re currently not enabled for this program.",
	"page.merchants.programme.canApply.2": "Apply for this program now.",
	"page.merchants.programme.notFound": "Program not found",
	"page.merchants.programme.yourTrackingLink": "Your tracking link",
	"page.merchants.programmes.backToAvailableProgrammes": "Back to available programs",
	"page.merchants.programmes.backToYourProgrammeApplications": "Back to your applications",
	"page.merchants.programmes.backToYourProgrammes": "Back to your programs",
	"page.merchants.programmes.lookupApplicationsNow": "View applications",
	"page.merchants.programmes.lookupAvailableProgrammesNow": "View available programs",
	"page.merchants.programmes.noActiveApplicationsFound.1": "You haven’t applied to any programs yet.",
	"page.merchants.programmes.noActiveApplicationsFound.2": "Check available programs now.",
	"page.merchants.programmes.noAvailableProgrammes": "No available programs. This means the merchant has no further programs or you’re not enabled for any.",
	"page.merchants.programmes.noProgrammesFound": "You’re currently not enabled for any program.",
	"page.merchants.programmes.title": "Programs",
	"page.merchants.submission.title": "Your submission for \"{name}\"",
	"page.merchants.submissions.submissions.subtitle": "Check out the available campaigns and apply directly!",
	"page.merchants.submissions.submissions.title": "No Submissions Available Yet",
	"page.merchants.submissions.title": "Submissions",
	"page.merchants.videoSubmission.title": "Submit video",
	"page.mfa.pageTitle": "Multi-Factor Authentication",
	"page.mfa.subtitle": "Please enter the code from your authenticator app.",
	"page.mfa.title": "Your Account is Additionally Protected",
	"page.newCampaign.step.briefing.description": "Campaign Definition and Requirements",
	"page.newCampaign.step.briefing.title": "Step 3 – Languages & Briefing",
	"page.newCampaign.step.required.description": "The Basic Information for Your Campaign",
	"page.newCampaign.step.required.title": "Step 1 – Campaign",
	"page.newCampaign.step.setup.description": "Upload a Thumbnail and Determine the Length, Duration, and Target Countries of the Campaign",
	"page.newCampaign.step.setup.title": "Step 2 – Setup",
	"page.newPassword.label.password": "New password",
	"page.newPassword.label.passwordConfirm": "Confirm new password",
	"page.newPassword.title": "Set new password",
	"page.productRedirect.demo.subtitle": "In demo mode, redirecting to the product is not possible",
	"page.productRedirect.demo.title": "Demo Mode",
	"page.productRedirect.error.notFound.subtitle": "Unfortunately, we could not find a product page for the product with the number \"{0}\".",
	"page.productRedirect.error.notFound.title": "Redirection not possible",
	"page.productRedirect.waitForRedirect": "You are being redirected to the product page...",
	"page.productReport.cards.topSeller.subtitle": "of the last {0} days",
	"page.productReport.cards.topSeller.title": "Your top sellers",
	"page.productReport.cards.topSum.subtitle": "of the last {0} days",
	"page.productReport.cards.topSum.title": "Your top earners",
	"page.profile.autoUpdateUserProfile": "Your profile is being updated...",
	"page.programme.promotionLinks.subtitle": "Copy the biggest program deals with one click!",
	"page.programme.promotionLinks.title": "Personalized promotion links",
	"page.programmes.apply.error.subtitle": "We could not determine your application status or send your application. If the problem persists, please contact our support.",
	"page.programmes.apply.error.title": "Error in Program Application",
	"page.programmes.apply.pageTitle": "Application",
	"page.programmes.apply.signupPageTitle": "Registration",
	"page.programmes.apply.waitForProgram": "Waiting for program...",
	"page.resetPassword.subtitle": "We’ve sent you an email to reset your password at {email}.",
	"page.resetPassword.title": "Reset password",
	"page.signup.acceptTosOnSignup": "By registering, you accept the {tos}",
	"page.signup.acceptTosOnSignup.tos": "Terms and Conditions",
	"page.signup.bauhaus.waitlist.greeting": "Dear Bauhaus fans,",
	"page.signup.bauhaus.waitlist.text": "Due to the high demand for our affiliate program, we are unfortunately unable to onboard any further affiliates at the moment. Please register to be added to the waiting list. We will get in touch with you as soon as we have capacity again.",
	"page.signup.confirmYourEmail.subtitle": "We’ve sent you a confirmation email. Please confirm your email address to continue with registration.",
	"page.signup.confirmYourEmail.title": "Confirm your email address",
	"page.signup.label.email": "Email address",
	"page.signup.label.firstName": "First name",
	"page.signup.label.lastName": "Last name",
	"page.signup.label.or": "or",
	"page.signup.label.password": "Password",
	"page.signup.pageTitle": "Signup",
	"page.signup.profile.approveSignup": "Confirm signup",
	"page.signup.profile.label.firstName": "First name",
	"page.signup.profile.label.lastName": "Last name",
	"page.signup.profile.subtitle": "We need to get to know you better before we can continue.",
	"page.signup.profile.title": "Confirm your account",
	"page.signup.subtitle.withMerchant": "Sign up now for the \"{merchant}\" affiliate program",
	"page.signup.subtitle.withoutMerchant": "Sign up now at Clickfire!",
	"page.signup.thomann.requirement.1": "Minimum 500 Unique Visits per day on websites",
	"page.signup.thomann.requirement.2": "Minimum 5.000 Followers on Social-Media-Channels",
	"page.signup.thomann.requirement.readMore.link": "here",
	"page.signup.thomann.requirement.readMore.text": "You can find further information on this {link}.",
	"page.signup.thomann.requirement.title": "Please keep in mind that the following requirements have to be met when signing up:",
	"page.signup.title": "Welcome 😊",
	"page.signupConfirm.waitingForConfirmation": "Completing registration...",
	"page.signupMigration.otp.subtitle": "We've sent a verification code to your email address. Please enter it here.",
	"page.signupMigration.otp.title": "Enter the verification code",
	"page.signupMigration.setPassword.subtitle": "Once you've set a password, you can sign in as usual via the standard Clickfire v2 login.",
	"page.signupMigration.setPassword.title": "Save password",
	"page.signupMigration.subtitle": "To help us identify you, we need your email address.",
	"page.signupMigration.title": "Great to see you in the new Clickfire!",
	"page.v1redirect.waitingForRedirect": "You are being redirected...",
	"page.v1signin.waitingForLogin": "You are being logged in...",
	"paymentType.intlTransfer": "SWIFT",
	"paymentType.paypal": "PayPal",
	"paymentType.sepa": "Wire transfer",
	"placeholder.password": "Enter password",
	"popover.application.doubleCheck": "Confirm Action:",
	"popover.embedCodeCopiedSuccessfully": "Code copied!",
	"popover.linkCopiedSuccessfully": "Link copied!",
	"popover.segmentCreators.doubleCheck": "Remove Creator from segment?",
	"productWidget.copy.embedDescription": "Place this code block where you want the widget to appear. Together with the script tag, your configured widget will be loaded there.",
	"productWidget.copy.embedLabel": "Widget code",
	"productWidget.copy.scriptDescription": "Add this script tag to the <head> of your page. It is required so the widget can be loaded and filled with content.",
	"productWidget.copy.scriptLabel": "Script tag",
	"productWidget.copy.title": "Embed widget",
	"productWidget.create.button": "Create widget",
	"productWidget.delete.cancelLabel": "Cancel",
	"productWidget.delete.confirmDescription": "You can still keep using the widget on your website, but you will no longer be able to view any analytics.",
	"productWidget.delete.confirmLabel": "Delete",
	"productWidget.delete.confirmTitle": "Do you really want to delete the product widget “{name}”?",
	"productWidget.delete.error": "Error deleting product widget “{name}”.",
	"productWidget.delete.success": "Product widget “{name}” has been deleted.",
	"productWidget.domain.admin.actionError": "The action could not be completed. Please try again.",
	"productWidget.domain.admin.publisherId": "ID: {id}",
	"productWidget.domain.admin.registrationFor": "Domain registration for",
	"productWidget.domain.delete.cancelLabel": "Cancel",
	"productWidget.domain.delete.confirmDescription": "After deletion, your product widgets will no longer work on this domain.",
	"productWidget.domain.delete.confirmLabel": "Delete",
	"productWidget.domain.delete.confirmTitle": "Do you really want to delete the domain “{name}”?",
	"productWidget.domain.delete.error": "{domain} could not be deleted. Please try again.",
	"productWidget.domain.delete.success": "{domain} has been deleted.",
	"productWidget.domain.form.invalidDomain": "Please enter a valid domain (e.g. your-site.com).",
	"productWidget.domain.status.accepted": "Accepted",
	"productWidget.domain.status.rejected": "Rejected",
	"productWidget.domain.status.submitted": "Submitted",
	"productWidget.domain.submit.button": "Submit domain",
	"productWidget.domain.submit.error": "The domain could not be submitted. Please try again.",
	"productWidget.domain.submit.placeholder": "your-site.com",
	"productWidget.domain.submit.success": "{domain} has been submitted for review.",
	"productWidget.domain.submit.validationError": "Please enter a valid domain.",
	"productWidget.domain.table.delete": "Delete domain",
	"productWidget.domain.table.empty": "No domains submitted yet.",
	"productWidget.domain.table.name": "Domain name",
	"productWidget.domain.table.status": "Status",
	"productWidget.domain.table.submittedAt": "Submitted on",
	"productWidget.domainPending.description": "Great! You've added a domain. You can already create product widgets, but they will only work technically on your website once we've approved the domain.",
	"productWidget.domainRejected.description": "Unfortunately your domain was rejected. To use product widgets you need at least one active domain. You can {domainLink} now or contact our {supportLink} if you have any questions.",
	"productWidget.domainRejected.domainLink": "submit another domain",
	"productWidget.domainRejected.supportLink": "support team",
	"productWidget.duplicate.copySuffix": " (Copy)",
	"productWidget.edit.configuratorTitle": "Edit widget",
	"productWidget.edit.notFound": "This product widget could not be found.",
	"productWidget.edit.saveButton": "Save changes",
	"productWidget.edit.saveError": "Changes could not be saved. Please try again.",
	"productWidget.edit.saveSuccess": "Changes have been saved.",
	"productWidget.empty.features.catalog.description": "Simply search products by name or number and embed them in the widget.",
	"productWidget.empty.features.catalog.title": "Integrated product catalog",
	"productWidget.empty.features.noCode.description": "Launch your own free web ads in minutes, no expertise required.",
	"productWidget.empty.features.noCode.title": "No web skills needed",
	"productWidget.empty.features.responsive.description": "Optimized for common device types like mobile, tablet and desktop.",
	"productWidget.empty.features.responsive.title": "Responsive design",
	"productWidget.empty.headline": "Turn product widgets into your visual product placement",
	"productWidget.empty.modalSubtitle": "Once you enter your domain, you can create your first product widget.",
	"productWidget.empty.notApproved": "You need to be approved for at least one program to use product widgets.",
	"productWidget.empty.subtitle": "With product widgets you can quickly and conveniently run visual ads on your website. You only need to have your domain approved by our affiliate managers.",
	"productWidget.new.backToOverview": "Back to widget overview",
	"productWidget.new.brandPlaceholder": "By brand…",
	"productWidget.new.buttonLabelDescription": "Shown on each product’s button, e.g. “View in shop”. If left empty, a default text is used.",
	"productWidget.new.buttonLabelShortDescription": "Replaces the button text when the widget is shown at a narrow width, e.g. on smartphones.",
	"productWidget.new.categoryPlaceholder": "By category…",
	"productWidget.new.configuratorTitle": "Widget configurator",
	"productWidget.new.createButton": "Create product widget",
	"productWidget.new.errors.name": "Please enter a widget name.",
	"productWidget.new.errors.productCount": "Please set the number of products.",
	"productWidget.new.errors.products": "Please add at least one product.",
	"productWidget.new.errors.programme": "Please select a program ID.",
	"productWidget.new.errors.shop": "Please select a shop.",
	"productWidget.new.errors.title": "Please fix the following:",
	"productWidget.new.fields.buttonLabel": "Button text",
	"productWidget.new.fields.buttonLabelShort": "Button text (short)",
	"productWidget.new.fields.layout": "Layout",
	"productWidget.new.fields.name": "Widget name",
	"productWidget.new.fields.payoutInfo": "Payout info",
	"productWidget.new.fields.productCount": "Product quantity slider",
	"productWidget.new.fields.programme": "Program ID",
	"productWidget.new.fields.quickSelect": "Quick select",
	"productWidget.new.fields.shop": "Shop",
	"productWidget.new.fields.sort": "Sorting",
	"productWidget.new.fields.subId": "Sub ID",
	"productWidget.new.fields.topsellerFilter": "Top seller filter",
	"productWidget.new.filter.individual": "Individual",
	"productWidget.new.filter.overall": "Overall",
	"productWidget.new.layout.centered": "Centered",
	"productWidget.new.layout.default": "Default",
	"productWidget.new.optional": "optional",
	"productWidget.new.previewHint": "To see a preview, you need to select at least one shop.",
	"productWidget.new.productCountValue": "{count} products",
	"productWidget.new.productSelection": "Product selection",
	"productWidget.new.programmePlaceholder": "Add your program ID here",
	"productWidget.new.saveError": "The product widget could not be saved. Please try again.",
	"productWidget.new.saveSuccess": "Product widget has been saved.",
	"productWidget.new.shopPlaceholder": "Select a shop",
	"productWidget.new.skuHint": "You can find the product numbers directly on the product page in the",
	"productWidget.new.skuPlaceholder": "Enter product number (SKU)",
	"productWidget.new.skuShopLink": "{shop} shop",
	"productWidget.new.sort.priceAsc": "Price ascending",
	"productWidget.new.sort.priceDesc": "Price descending",
	"productWidget.new.step.layout": "Layout",
	"productWidget.new.step.product": "Product",
	"productWidget.new.step.tracking": "Tracking",
	"productWidget.new.subIdDescription": "This sub ID is used for reporting purposes and is therefore generated automatically. Overriding it may cause issues with your reporting. Only change it if you know what you are doing.",
	"productWidget.new.subIdPlaceholder": "Sub ID (optional)",
	"productWidget.new.subcategoryPlaceholder": "By subcategory…",
	"productWidget.new.topsellerFilterDescription": "Overall shows the shop's top sellers. Individual filters the products dynamically.",
	"productWidget.new.type.dynamic": "Top seller",
	"productWidget.new.type.static": "Product search",
	"productWidget.preview.backToOverview": "Back to overview",
	"productWidget.preview.description": "This is how your widget will appear on your website.",
	"productWidget.preview.title": "Widget preview",
	"productWidget.table.actions.copyHtml": "Copy HTML",
	"productWidget.table.actions.delete": "Delete",
	"productWidget.table.actions.duplicate": "Duplicate",
	"productWidget.table.actions.edit": "Edit",
	"productWidget.table.actions.preview": "Preview",
	"productWidget.table.clicks": "Clicks",
	"productWidget.table.empty": "No product widgets created yet.",
	"productWidget.table.impressions": "Impressions",
	"productWidget.table.name": "Name",
	"productWidget.table.type": "Behavior",
	"programme.button.programmeDetails": "View details",
	"programme.hint.enableCompactUrl": "Short link provided by Clickfire",
	"programme.label.addSubIds": "Add sub-IDs",
	"programme.label.applicationStatus": "Status",
	"programme.label.appliedAt": "Applied at",
	"programme.label.creative": "Creative",
	"programme.label.customUrl": "Custom URL",
	"programme.label.enableCompactUrl": "Compact URL",
	"programme.label.note": "Note",
	"programme.noValidApplicationDate": "Unknown",
	"programme.placeholder.creative": "Select creative",
	"programme.placeholder.customUrl": "Enter your custom URL...",
	"programme.placeholder.subId1": "Sub ID 1",
	"programme.placeholder.subId2": "Sub ID 2",
	"programmeAccessStatus.grantedBy": "Access granted by {0}",
	"programmeAccessStatus.hasAccess": "Access granted",
	"programmeAccessStatus.noAccess": "No access",
	"programmeAccessStatus.onHold": "On hold",
	"programmeAccessStatus.pending": "Application pending",
	"programmeAccessStatus.rejected": "Rejected",
	"programmeAccessStatus.revokedBy": "Access revoked by {0}",
	"programmeApplication.acceptedBy": "Accepted by {0}",
	"programmeApplication.appliedToProgramme": "Application for",
	"programmeApplication.button.approve": "Accept application",
	"programmeApplication.button.approveDisabled": "Programme access can only be granted if a provision group has been assigned to the affiliate.",
	"programmeApplication.button.reject": "Reject application",
	"programmeApplication.details.city": "City:",
	"programmeApplication.details.country": "Country:",
	"programmeApplication.details.descriptionPromotionMethod": "How I want to promote the program",
	"programmeApplication.details.eMailAddress": "Email address:",
	"programmeApplication.details.highestReachCountry": "Country with greatest reach:",
	"programmeApplication.details.recommendedBy": "Recommended by:",
	"programmeApplication.details.title": "Applicant details",
	"programmeApplication.individualPayout.amountInPercent.label": "Percentage value (%)",
	"programmeApplication.individualPayout.description": "Overrides group commission",
	"programmeApplication.individualPayout.label": "Pay out individual payout",
	"programmeApplication.individualPayout.referrerBonus.label": "Referrer Bonus (%)",
	"programmeApplication.noChannelsData": "The applicant has not provided any information about their channels",
	"programmeApplication.onHold": "On Hold",
	"programmeApplication.rejectedBy": "Rejected by {0}",
	"programmeApplication.rejection.general": "General",
	"programmeApplication.rejection.policy": "Does not match Affiliate Policy",
	"programmeApplication.rejection.reach": "Reach too low",
	"programmeApplication.rejection.topic": "Not topic-specific",
	"reachFilter.all.label": "All reaches",
	"segments.label.singleUsers": "Individual Users",
	"sidebar.signedInAs": "Signed in as",
	"state.admin.submission.approved": "Accepted",
	"state.admin.submission.exceeded": "Expired",
	"state.admin.submission.missing": "Missing Submission",
	"state.admin.submission.rejected": "Rejected",
	"state.admin.submission.submitted": "Review",
	"state.approved": "Approved",
	"state.paid": "Paid",
	"state.pending": "Pending",
	"state.rejected": "Rejected",
	"state.submission.approved": "Submission Accepted",
	"state.submission.exceeded": "Submission Period Has Expired",
	"state.submission.missing": "Submission Required",
	"state.submission.paidOut": "Submission Paid Out",
	"state.submission.rejected": "Submission Rejected",
	"state.submission.submitted": "Being Reviewed",
	"state.unapproved": "Unapproved",
	"state.unknown": "Unknown",
	"submission.label.creationDate": "Submitted On",
	"submission.property.category": "Category",
	"submission.property.codeExpiryDate": "Validity period",
	"submission.property.compensation": "Compensation",
	"submission.property.createdAt": "Submission date",
	"submission.property.state": "Status",
	"submission.property.tiktokCode": "TikTok code",
	"submissionState": "Submission: {0}",
	"submissions.label.onlyShowOpenSubmissions": "Only Show Open Submissions",
	"submissions.noSubmissions.title": "No Submissions Available",
	"table.adminConversions.noEntries": "There are no conversions for the current selection",
	"table.adminPayouts.noEntries": "There are no payouts yet",
	"table.adminPayouts.title.actions": "Download",
	"table.adminPayouts.title.affiliate": "Affiliate",
	"table.adminPayouts.title.affiliateId": "Affiliate ID",
	"table.adminPayouts.title.compensation": "Amount",
	"table.adminPayouts.title.date": "Invoice date",
	"table.adminPayouts.title.id": "Invoice number",
	"table.adminPayouts.title.payout": "Payout amount",
	"table.adminSubmissions.noEntries": "There are no submissions for this campaign yet",
	"table.adminSubmissions.title.actions": "Accept",
	"table.adminSubmissions.title.affiliate": "Affiliate",
	"table.adminSubmissions.title.affiliateId": "Affiliate ID",
	"table.adminSubmissions.title.contentUrl": "Submission Link",
	"table.adminSubmissions.title.creator": "Publisher Name",
	"table.adminSubmissions.title.date": "Date",
	"table.adminSubmissions.title.details": "Details",
	"table.adminSubmissions.title.rejectionInformation": "Rejection Reason",
	"table.adminSubmissions.title.state": "Status",
	"table.applications.title.actions": "Application",
	"table.applications.title.applicationDate": "Application Date",
	"table.applications.title.categories": "Product Categories",
	"table.applications.title.creator": "Publisher Name",
	"table.applications.title.followerCount": "Followers",
	"table.applications.title.languages": "Languages",
	"table.applications.title.platforms": "Platforms",
	"table.applications.title.state": "Status",
	"table.clicks.noEntries": "You have no clicks yet",
	"table.conversions.noEntries": "You have no conversions yet",
	"table.conversions.title.invoiceNumber": "Credit note number",
	"table.conversions.title.orderNumber": "Order number",
	"table.conversions.title.partner": "Partner",
	"table.conversions.title.payout": "Commission",
	"table.conversions.title.programme": "Program",
	"table.conversions.title.rejectionReason": "Rejection reason",
	"table.conversions.title.saleAmount": "Sale amount",
	"table.conversions.title.status": "Approval status",
	"table.footer.entriesPerPage": "Entries per page",
	"table.generic.title.date": "Date",
	"table.generic.title.publisherId": "Publisher ID",
	"table.generic.title.referrer": "Referrer",
	"table.generic.title.subId1": "Sub ID 1",
	"table.generic.title.subId2": "Sub ID 2",
	"table.networkReport.noEntries": "No matching partners found",
	"table.noEntries": "No entries yet",
	"table.payouts.footer.payoutSum": "Total payouts",
	"table.payouts.noEntries": "You have no payouts yet",
	"table.payouts.title.actions": "Download",
	"table.payouts.title.amount": "Payout amount",
	"table.payouts.title.date": "Invoice date",
	"table.payouts.title.id": "Invoice number",
	"table.payouts.title.merchant": "Merchant",
	"table.pecHistory.campaignCompleted": "Campaign completed",
	"table.pecHistory.campaignOngoing": "Campaign still running",
	"table.pecHistory.hasSubmission": "Submission present",
	"table.pecHistory.noEntries": "No campaign participations found",
	"table.pecHistory.noSubmission": "No submission",
	"table.pecHistory.title.campaignCompleted": "Campaign completed",
	"table.pecHistory.title.campaignName": "Campaign name",
	"table.pecHistory.title.company": "Company",
	"table.pecHistory.title.compensationReceived": "Compensation received",
	"table.pecHistory.title.status": "Application status",
	"table.products.noEntries": "No transactions found",
	"table.products.title.articleNumber": "Article no.",
	"table.products.title.category": "Category",
	"table.products.title.grossNet": "Revenue (net)",
	"table.products.title.grossSum": "Revenue (gross)",
	"table.products.title.imageUrl": "Image",
	"table.products.title.name": "Name",
	"table.products.title.priceGross": "Price (gross)",
	"table.products.title.priceNet": "Price (net)",
	"table.products.title.quantity": "Quantity",
	"table.segmentCreators.empty.action": "Add Creators",
	"table.segmentCreators.empty.description": "No Creators have been added to this Creator Segment yet.",
	"table.segmentCreators.empty.title": "No Creators available",
	"table.segmentCreators.title.actions": "Actions",
	"table.submissions.emptyState": "No submissions available",
	"table.submissions.title.campaign": "Campaign",
	"table.submissions.title.date": "Date",
	"table.submissions.title.details": "Details",
	"table.submissions.title.merchant": "Merchant",
	"table.submissions.title.state": "Status",
	"toast.applyToProgramme.error.alreadyApproved": "You’re already enabled for this program.",
	"toast.applyToProgramme.error.applicationPending": "You’ve already applied for this program.",
	"toast.applyToProgramme.error.description": "An unknown error occurred. Please try again or contact our support.",
	"toast.applyToProgramme.error.title": "Error applying",
	"toast.applyToProgramme.needsToCompleteAccountSetup.title": "You must complete your account setup before applying for this program.",
	"toast.applyToProgramme.rejectedByMerchant.title": "Unfortunately, you were rejected for the network and therefore cannot apply for the program",
	"toast.applyToProgramme.success.title": "Application submitted successfully",
	"toast.approveSubmission.success.title": "Submission approved successfully",
	"toast.archiveCampaign.success.title": "Campaign archived successfully",
	"toast.campaigns.translateWithAi.noSourceLocalization": "To allow the AI to translate your content, at least one language must be fully filled out.",
	"toast.changeBillingInformation.error.title": "Error updating billing information",
	"toast.changeBillingInformation.success.title": "Your billing information has been updated successfully",
	"toast.changeBillingInformation.unknownError.title": "An unknown error occurred while updating billing information",
	"toast.changePaymentInformation.error.title": "Error submitting payment information",
	"toast.changePaymentInformation.success.title": "Your payment information has been updated successfully",
	"toast.changePaymentInformation.unknownError.title": "An unknown error occurred while submitting payment information",
	"toast.changeQuestionaireInformation.error.title": "Error submitting questionnaire information",
	"toast.changeQuestionaireInformation.unkownError.title": "An unknown error occurred while submitting questionnaire information",
	"toast.changeQuestionnaireData.error.title": "Error updating application data",
	"toast.changeQuestionnaireData.success.title": "Your application data has been updated successfully",
	"toast.changeQuestionnaireData.unknownError.title": "An unknown error occurred while updating application data",
	"toast.confirmedEmailButNeedLogin.description": "You can now log in with your email address and password",
	"toast.confirmedEmailButNeedLogin.title": "Your email has been confirmed successfully",
	"toast.copyPromotionLink.error": "Error copying link. Please try again.",
	"toast.createProfile.error.title": "Profile creation failed",
	"toast.createProgrammeLink.error.description": "Please try again.",
	"toast.createProgrammeLink.error.title": "The link could not be created",
	"toast.dateRangePickerMaxRange.error.description": "You can select a date range of up to {duration}.",
	"toast.dateRangePickerMaxRange.error.title": "Date range too long",
	"toast.downloadAsCsv.error.title": "Error during CSV Download",
	"toast.downloadReportAsCsv.error.invalidDate": "The specified date is invalid.",
	"toast.downloadReportAsCsv.error.noItems": "No results were found.",
	"toast.downloadReportAsCsv.error.parse": "The data could not be processed.",
	"toast.downloadReportAsCsv.error.server": "The report could not be loaded. Please try again later.",
	"toast.editCampaign.success.title": "Campaign updated successfully",
	"toast.isRedirectedFromAnotherSpace.description": "You have tried to log in to another merchant. For security reasons, you must enter your login details again.",
	"toast.isRedirectedFromAnotherSpace.title": "You have to log in again",
	"toast.login.error.title": "Login failed",
	"toast.newCampaign.error.title": "An error occurred while creating the campaign",
	"toast.newCampaign.success.title": "Campaign created successfully",
	"toast.newPassword.error.title": "Password could not be changed",
	"toast.newPassword.success.title": "Password changed successfully!",
	"toast.rejectSubmission.success.title": "Submission rejected successfully",
	"toast.resetPassword.error.title": "Password could not be reset",
	"toast.saveChannels.error.description": "One or more channels could not be saved or deleted.",
	"toast.saveChannels.error.title": "Error saving channels",
	"toast.signup.error.title": "Registration failed",
	"toast.signupWithV1Account.error.description": "An unknown error occurred during registration. Please check your information or try again later.",
	"toast.signupWithV1Account.error.title": "Registration error",
	"toast.submitSubmission.error.title": "Error submitting",
	"toast.submitSubmission.unknownError.title": "An unknown error occurred while submitting",
	"toast.unauthorized.description": "Your session has expired. Please sign in again.",
	"toast.unauthorized.title": "You need to sign in again",
	"toast.updateAccount.admin.success.title": "Profile updated successfully",
	"toast.updateAccount.error.title": "Your account could not be updated",
	"toast.updateAccount.success.title": "Your account has been updated successfully",
	"toast.updateCampaign.success.title": "Campaign Successfully Saved",
	"toast.updateChannels.success.title": "Your channel information has been saved successfully",
	"toast.validation.error.description": "Please check the highlighted fields.",
	"toast.validation.error.title": "Your input is incomplete",
	"tooltip.blocked": "Access blocked",
	"tooltip.cpi.body": "Calculated from the volume and value of conversions generated by the creator in the last 90 days. The higher the value, the better. A maximum score of 10 can be achieved.",
	"tooltip.cpi.title": "Clickfire Performance Index:",
	"tooltip.customProgrammePayoutModality": "For this program, you have a personalized commission rate that is higher than the standard commission.",
	"tooltip.inactive": "The user has no conversions yet, so we classify them as inactive.",
	"tooltip.inactive.withDate": "The user's last conversion was on {0}, so we classify them as inactive.",
	"tooltip.v1User.description": "The user hasn't signed in to Clickfire v2 yet, so we can't display all data.",
	"tooltip.v1User.label": "v1 user",
	"topbar.links.admin.applications.history": "Application History",
	"topbar.links.admin.applications.onhold": "Deferred Applications",
	"topbar.links.admin.applications.open": "Open Applications",
	"topbar.links.admin.campaigns.active": "Active Campaigns",
	"topbar.links.admin.campaigns.archived": "Archive",
	"topbar.links.admin.campaigns.draft": "Drafts",
	"topbar.links.affiliates": "Affiliates",
	"topbar.links.applications": "Application Overview",
	"topbar.links.availableCampaigns": "Available Campaigns",
	"topbar.links.availableProgrammes": "Available Programs",
	"topbar.links.campaigns": "Campaigns",
	"topbar.links.clickReport": "Click report",
	"topbar.links.clickReportRealtime": "Realtime Clicks",
	"topbar.links.conversions": "Conversion report",
	"topbar.links.dashboard": "Dashboard",
	"topbar.links.domains": "Domains",
	"topbar.links.partnerReport": "Network Report",
	"topbar.links.payouts": "Payouts",
	"topbar.links.productReport": "Product report",
	"topbar.links.productWidget": "Product Widget",
	"topbar.links.productWidgetsOverview": "Overview",
	"topbar.links.programmes": "Programs",
	"topbar.links.segments": "Creator Segments",
	"topbar.links.submissions": "Submissions",
	"topbar.links.yourProgrammeApplications": "Your Applications",
	"topbar.links.yourProgrammes": "Your Programs",
	"topbar.userMenu.links.account": "Profile settings",
	"topbar.userMenu.links.adminDashboard": "Merchant dashboard",
	"topbar.userMenu.links.logout": "Log out",
	"topbar.userMenu.links.merchantDashboard": "Affiliate dashboard",
	"validation.error.bic": "Invalid BIC",
	"validation.error.campaign.localizationMinimum": "At least one language must be specified.",
	"validation.error.campaign.type": "A campaign type must be selected.",
	"validation.error.compensation": "Compensation must be at least €0.01",
	"validation.error.confirmTos": "Agreeing to the terms & conditions is required",
	"validation.error.default": "Invalid input",
	"validation.error.duplicate.channelUri": "This URL is used for more than one channel",
	"validation.error.email": "Invalid email address",
	"validation.error.endDate": "End date cannot be earlier than {0}",
	"validation.error.endDate.atLeastOneDay": "The date cannot be today or in the past",
	"validation.error.endDate.onlyExtendAllowed": "You can only extend the end date, not shorten it.",
	"validation.error.iban": "Invalid IBAN",
	"validation.error.invalid.date": "Invalid date",
	"validation.error.invalid.url": "Invalid URL",
	"validation.error.invalidImageDimensions": "Image resolution is too low. Please use an image with at least {width}x{height}px.",
	"validation.error.invalidImageFormat": "Please select a valid file format ({0})",
	"validation.error.length": "This field must contain at least {0} characters.",
	"validation.error.localization.atLeastOne": "At least one language must be filled in",
	"validation.error.notANumber": "Invalid number",
	"validation.error.notAnImage": "Please select a valid image",
	"validation.error.notEqual": "Passwords do not match",
	"validation.error.number.noFloat": "This field may not contain numbers with , or .",
	"validation.error.postalCode": "No valid postal code for {country}",
	"validation.error.required": "This field is required",
	"validation.error.startDate": "The start date cannot be earlier than {0}",
	"validation.error.tags.required": "At least one content tag is required",
	"validation.error.tooBig.number": "The number cannot be larger than {0}.",
	"validation.error.tooSmall.array": "This field is required",
	"widget.affilateDetails.accountManager": "Account manager",
	"widget.affilateDetails.subId1": "Affiliate sub-ID 1",
	"widget.affilateDetails.subId2": "Affiliate sub-ID 2",
	"widget.affilateDetails.title": "Affiliates",
	"widget.networkSelectionPerformanceGraph.action.clearSelection": "Clear selection",
	"widget.networkSelectionPerformanceGraph.action.removeFromSelection": "Remove from selection",
	"widget.networkSelectionPerformanceGraph.label.selection": "Selection:",
	"widget.networkSelectionPerformanceGraph.label.wholeNetwork": "Entire network",
	"widget.payment.billingAndTaxes.title": "Billing & Taxes",
	"widget.payment.billingData.title": "Billing Data",
	"widget.payment.misc.title": "Miscellaneous",
	"widget.payment.paymentInfo.title": "Payment Information",
	"widget.performanceGraph.label.clicks": "Clicks",
	"widget.performanceGraph.label.conversions": "Conversions",
	"widget.performanceGraph.label.payouts": "Commission value",
	"widget.performanceGraph.label.sales": "Sales Value",
	"widget.performanceGraph.missingPublisherId.description": "Performance data cannot be loaded for this partner.",
	"widget.performanceGraph.missingPublisherId.title": "No publisher ID stored",
	"widget.performanceGraph.showUnapprovedConversions": "Show pending conversions",
	"widget.performanceGraph.title": "Performance graph",
	"widget.performanceGraph.trend": "Trend",
	"widget.topProducts.noContent": "No products found for this period.",
	"widget.yourAffiliateLinks.title": "Your affiliate links",
	"widget.yourApplications.title": "Your application status"
}
